import React from 'react';

export default function LoadingSpinner({ size = 28, text = "Loading..." }) {
  return (
    <div
      className="rv-loading-container"
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        padding: "32px 16px",
        gap: "10px",
        color: "#8A7A6B",
        fontSize: "12.5px",
        fontWeight: 500,
        width: "100%",
      }}
    >
      <div
        className="rv-spinner"
        style={{
          width: size,
          height: size,
          border: "2.5px solid rgba(160, 120, 80, 0.2)",
          borderTopColor: "#A07850",
          borderRadius: "50%",
          animation: "rvSpin 0.75s linear infinite",
        }}
      />
      {text && <span>{text}</span>}
      <style>{`
        @keyframes rvSpin {
          to { transform: rotate(360deg); }
        }
      `}</style>
    </div>
  );
}
